exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\ndiv.programs-list {\n  margin: 30px 0;\n}\ndiv.programs-list ul.tile-list {\n  padding-right: 0px;\n}\ndiv.programs-list ul.tile-list li.programs {\n  display: inline-block;\n  margin-right: 15px;\n  vertical-align: top;\n  width: 31%;\n  margin-bottom: 15px;\n  position: relative;\n}\ndiv.programs-list ul.tile-list li.programs a:hover {\n  text-decoration: none;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/programs/programs.component.less
// module id = ../../../../../src/app/dashboard/program-list/programs/programs.component.less
// module chunks = 2